import './DesktopEngine.scss';
import { motion } from 'framer-motion';
import Carousel from '../Carousel/CarModelEngineCarousel';
import CloseIcon from '../../../../../assets/icons/close.svg';
import React from 'react';
import Marks from '../Marks/CarModelEngineMarks';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function CarModelEngineDesktop({
  data,
  swiperRef,
  onClickMark,
  onClose,
  setSlideIndex,
}) {
  // const isOpen = data?.marksJaecooJ7Phev.some((el: Mark) => el.open);
  const isOpen = data.marks.some((el) => el.open);

  return (
    <div className={'car-model-engine-desktop'}>
      <div className={'wrapper'} data-aos="fade-up">
        <motion.div
          className={'left'}
          initial={{ width: 0, opacity: 0 }}
          animate={{ width: isOpen ? '35%' : 0, opacity: isOpen ? 1 : 0 }}
          transition={{ duration: 0.7, ease: 'easeInOut' }}
        >
          <Carousel marks={data.marks} swiperRef={swiperRef} setSlideIndex={setSlideIndex} />
        </motion.div>
        <motion.div
          className={'right'}
          initial={{ width: '100%', opacity: 1 }}
          animate={{ width: isOpen ? '65%' : '100%', opacity: 1 }}
          transition={{ duration: 0.7, ease: 'easeInOut' }}
        >
          <div className={'right_image'}>
            <Image field={data.image} alt={'img'} fill />
          </div>
          <Marks data={data} onClickMark={onClickMark} />
          <motion.button
            className={'right_close'}
            onClick={onClose}
            initial={{ visibility: 'hidden', opacity: 0 }}
            animate={{ visibility: isOpen ? 'visible' : 'hidden', opacity: isOpen ? 1 : 0 }}
            transition={{ duration: 0.7, ease: 'easeInOut' }}
          >
            <img src={CloseIcon} alt={'x'} />
          </motion.button>
        </motion.div>
      </div>
    </div>
  );
}
